import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useEffect, useRef, useState } from "react";
import TabsComponent from "./tabs";
import InfoCard from "./infocard";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import api from "../api/api";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Enrollpatient from "./modals/enrollpatient";
import { Backdrop, Chip,Button , CircularProgress } from "@mui/material";
import RpmNote from "./modals/notes";
import ToastMessage from "../utils/mui/righttoptoast";
import Risk from "./modals/risk";
import EditPatient from "./modals/editpatient";
import ChatWrapper from "../header/chat/chatwrapper";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import FilterPopUp from "./modals/filterPopup";
import RpmCard from "./modals/rpmcard";
import AddIcon from '@mui/icons-material/Add';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RpmFilter from "./modals/RpmFilter";
import InfiniteScroll from "react-infinite-scroll-component";

const Rpm = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(false);
   const [chat,setChat]=useState(false)
   const Navigate= useNavigate()
    const [selectedFilterscount, setSelectedFilterscounts] = useState({
       reviewedStatus: [],
       billing: [],
       enrolledPrograms: [],
       unassigns: [],
     });
     const [isRpmCard,setRpmCard]=useState(false)
     const [isSearching, setIsSearching] = useState(false);
const [searchParams] = useSearchParams();
const pid = searchParams.get("pid");

  const[rpmdata,setRpmData]=useState([])
  const [dataLoading, setDataLoading] = useState(false); // Separate loading for fetchdata
  const [enrollform, setEnrollForm] = useState(false);
  const[filterpopup,setFilterPopup]=useState(false)
  const[notesform,setNotesForm]=useState(false)
  const [selectedCard,setSelectedCard]=useState({})
  const[riskmodal,setRiskmodal]=useState(false)
  const[editpatient,setEditPatient]=useState(false)
  const[searchvalue,setSearchValue]=useState('')
  const [flagupdate,setFlagupdate]=useState(false)
  const [filterrpmmodal, setFilterrpmmodal] = useState(false);
  const [filterReset, setFilterReset] = useState(false);
  const [limit,setLimit]=useState(10);
  const LimitRef=useRef();
  const practiseid = window.getPracticeId();

  const handleFilterOpen = () => {
    setFilterrpmmodal(true);  // This will open the modal
  };

  const handleFilterClose = () => {
    setFilterrpmmodal(false);  // This will close the modal
  };
  const filterLabels = {
    reviewedStatus: "Reviewed Status",
    billing: "Billing",
    enrolledPrograms: "Enrolled Programs",
    unassigns: "Unassigns",
  };
  const [enrolltype, setEnrollType] = useState('c');
  const { id, dt } = useParams();
      const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
const navigate = useNavigate();
      const [toastSeverity, setToastSeverity] = useState('success');
      const debounceTimer = useRef(null);
  const currentDate = useSelector((state) => state.filter.currentDate);
  const [tabs, setTabs] = useState([
    { label: "All", width: 44, count: 0 },
    { label: "Eligible", width: 44, count: 0 },
    { label: "Non-Eligible", width: 64, count: 0 },

  ]);
  // setToastMessage(response.message);
  // setToastSeverity('info');
  // setOpenToast(true);
const handletabs=(x)=>{
    setIsSearching(false);  
  resetFiltercount()
  setLimit(10); 
setSelectedTab(x)
console.log(x)
if(x===0){
  fetchdata({billeligible:null,billnoteligible:null })
}else if(x===1){
  fetchdata({billeligible:"CNTA" })
}else if(x===2){
  fetchdata({billnoteligible:"CNTB"})
}
}

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const fetchCount = async () => {
    setLoading(true);
    try {
      const response = await api.post(`/v1/${practiseid}/appointments/dbscounts`, {
        "type": "RPM",
        "userid": "all",
        "searchdate": currentDate,
      });
      if (response.status === 200 && response.data && response.data.length > 0) {
        const counts = response.data[0]; // Extracting the counts object from response'
        console.log(counts)
        const updatedTabs = tabs.map((tab) => {
          switch (tab.label) {
            case "Eligible":
              return { ...tab, count: counts.eligible };
            case "Non-Eligible":
              return { ...tab, count: counts.noteligible };
            case "High Risk":
              return { ...tab, count: counts.highrisk };
            case "Call Back":
              return { ...tab, count: counts.callback };
            case "Device Recall":
              return { ...tab, count: counts.devicerecall };
            default:
              return tab;
          }
        });
        console.log(updatedTabs)
        setTabs(updatedTabs,'up');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchdata = async (payload) => {
    setDataLoading(true); // Set data loading to true
    try {
      const response = await api.post(`/v1/${practiseid}/rpm/get`,{ ...{
        "searchflag": null,
        "billeligible": null,
        "billnoteligible": null,
        "highriskpat": null,
        "callbackpat": null,   
        "devicebackpat": null,
        "enrolldt": "desc",
        "tbllmt": null,
        "lastreadsortby": null,
        "limit":limit,
        "start": "0",
        "status": [],
        "billing": [],
        "enroll": [],
        "deviceUnassign": [],
        "is_rpmfilter": false,
        "pending_authorization": ""
      },...payload,});
      if(response.status==200){
        if (limit === 10) {
          // First load, replace existing data
          setRpmData(response.data);
        } else {
          // Append new data to the existing data
          setRpmData(response.data);
        }
      }else{
        setRpmData([])
      }
    } catch (error) {
      console.log(error);
      setRpmData([])
    } finally {
      setDataLoading(false); // Set data loading to false
    }
  };
  const handleLoadMoreData = () => {
    setLimit(prevLimit => prevLimit + 10);  // Increase limit by 10 for every scroll
  };

useEffect(() => {
  document.title = "CHIM - RPM Patients";
  if (!isSearching&&!pid) {
    fetchdata();
  }
}, [limit]);


  const loadData = async (flag) => {   
    try {
      const response = await api.post(`/v1/${practiseid}/rpm/get`, {
        "searchflag": flag||null,
        "billeligible": null,
        "billnoteligible": null,
        "highriskpat": null,
        "callbackpat": null,
        "devicebackpat": null,
        "enrolldt": "desc",
        "tbllmt": null,
        "lastreadsortby": null,
        "limit":'0',
        "start": "0",
        "status": [],
        "billing": [],
        "enroll": [],
        "deviceUnassign": [],
        "is_rpmfilter": false,
        "pending_authorization": ""
      });
      if(response.status==200){
        setRpmData(response.data)
      }else{
        setRpmData([])
      }
    } catch (error) {
      console.log(error);
    } finally {
      
    }
  }
  // useEffect(() => {
  //   fetchCount();
    
  //   fetchdata({billeligible:null,billnoteligible:null});
  // }, []);
const pidHandled = useRef(false);

useEffect(() => {
  fetchCount();

  if (pid && !pidHandled.current) {
    pidHandled.current = true;  // Mark as handled
    setIsSearching(true);
    fetchdata({
      searchflag: pid,
      limit: 0,
    });
    // Remove pid from URL silently
    navigate(window.location.pathname, { replace: true });
  } else if (!pid && !pidHandled.current) {
    // Only fetch all data if pid was never involved
    fetchdata({ billeligible: null, billnoteligible: null });
  }
}, [pid]);

const handleSearch = (e) => {
  const value = e.target.value;
  setSearchValue(value);
  resetFiltercount();

  if (debounceTimer.current) {
    clearTimeout(debounceTimer.current);
  }

  debounceTimer.current = setTimeout(() => {
    if (!value) {
      setIsSearching(false);
      setSelectedTab(0);
      fetchdata({ billeligible: null, billnoteligible: null });
    } else {
      setIsSearching(true);
      loadData(value);
    }
  }, 600);
};

  const resetFiltercount=()=>{setSelectedFilterscounts({
    reviewedStatus: [],
    billing: [],
    enrolledPrograms: [],
    unassigns: [],
  })}

  return (
    <div className="h-full">
      <SideNavLayout>
        <div className="w-full flex justify-end">
          <div className="relative w-full max-w-md">
            <div className="flex items-center w-[80%] bg-[#F5F6FA] border border-[#D5D5D5] rounded-[15px]">
              <FontAwesomeIcon
                icon={faSearch}
                className="text-gray-400 ml-3"
              />
              <input
              value={searchvalue}
              onChange={(e)=>handleSearch(e)}
                type="text"
                className="bg-[#F5F6FA] flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[15px]"
                placeholder="Search"
              />
            </div>
        

          </div>
        </div>
        <div className="flex w-[90%] gap-1 flex-wrap my-2 justify-between ">
          <div className="flex  gap-1 flex-wrap my-2 items-center ">
      <div>
        <button
        onClick={()=>setFilterPopup(true)}
          className=" bg-[#E179548F] text-[black] font-semibold text-[12px] h-8 w-30 px-2 rounded hover:bg-[#D97842] hover:text-white focus:bg-[#D97842] focus:text-white"
        >
        <ArrowDropDownIcon />  RPM Patients
        </button>
      </div>
      <div>
      <button
    onClick={() => setEnrollForm(true)}
    className=" text-[black] font-semibold text-[12px] h-8 w-30 px-3 rounded hover:bg-[#D97842] hover:text-white focus:bg-[#D97842] focus:text-white"
    >
    <AddIcon style={{width:'15px'}}/>
    Enroll Patient
  </button>
      </div>
      <div>
        <button
        onClick={()=>Navigate('/rpm-devices')}
        className="  text-[black] font-semibold text-[12px] h-8 w-30 px-3 rounded hover:bg-[#D97842] hover:text-white focus:bg-[#D97842] focus:text-white"
        >
        <AddToQueueIcon style={{width:'15px'}}/>  Devices
        </button>
      </div>
      <div>
        <button
          onClick={()=>Navigate('/rpm-reports')}
          className="  text-[black] font-semibold text-[12px] h-8 w-30 px-3 rounded hover:bg-[#D97842] hover:text-white focus:bg-[#D97842] focus:text-white"
        >
        <SignalCellularAltIcon style={{width:'15px'}}/>Reports
        </button>
      </div>
      <div>
        <button   onClick={()=>Navigate('/rpm-analytics')}
             className="  text-[black] font-semibold text-[12px] h-8 w-30 px-3 rounded hover:bg-[#D97842] hover:text-white focus:bg-[#D97842] focus:text-white"
             >
              {/* /rpm-analytics */}
             <MonitorHeartIcon style={{width:'15px'}} />  Analytics
        </button>
      </div>
      </div>
      <div className="flex">
      <div  onClick={handleFilterOpen} className="flex gap-2 justify-center items-center cursor-pointer  px-2"><FilterAltIcon/></div>
      <div className="flex gap-2 justify-center items-center cursor-pointer  px-2"   onClick={() => {
    resetFiltercount();
        pidHandled.current = false; 
           setIsSearching(false);       // ← also ensure searching is cleared
    setLimit(10);    
    fetchdata({ billeligible:null ,billnoteligible:null, 
                highriskpat: null, callbackpat: null, devicebackpat: null });
    setFilterReset(true);
    setSelectedTab(0)
  }} >     
  <RestartAltIcon
    style={{color:'#7B7575'}}
    className="transition-transform duration-300 transform hover:rotate-180"
  />
  <div className="text-[#7B7575]">Reset</div>
</div>
</div>
        </div>
{Object.values(selectedFilterscount).some((array) => array.length > 0) && (
  <div className="flex w-full items-center my-2">
    <div className="text-sm font-sans">Applied Filters:</div>
    <div className="flex flex-wrap ml-2">
      {Object.entries(selectedFilterscount).map(([filterName, filterItems]) =>
        filterItems.map((item, index) => (
          <Chip
            key={`${filterName}-${index}`}
            label={`${item}`}
            variant="outlined"
            style={{
              margin: "0 4px",
              color: "#000",
              maxWidth: "100%", // ensures the chip stays within available space
              flexShrink: 0, // prevents chips from shrinking
            }}
            className="text-xs h-6"
          />
        ))
      )}
    </div>
  </div>
)}



        <div className="w-full flex">
         
            <TabsComponent tabs={tabs} selectedTab={selectedTab} onSelectTab={handletabs} />
       
        </div>
        <div >
      <InfiniteScroll
        dataLength={rpmdata.length}  // Length of the currently loaded data
        next={handleLoadMoreData}  // Function to call for more data
        hasMore={rpmdata.length < 1000}  // Stop when 100 items are loaded (or another condition)
        loader={<></>}  // Loading spinner or message
        endMessage={<p className="text-[18px] text-gray-500">No more data to load.</p>}  // Message when no more data
      >
        <div className="w-full mt-4 flex flex-col gap-2 overflow-y-auto overflow-x-hidden">
  {rpmdata.length > 0 ? (
    rpmdata.map((card, index) => (
      <InfoCard key={index} data={card}
      setRpmCard={setRpmCard}
      setNotesForm={setNotesForm}
      setSelectedCard={setSelectedCard}
      setRiskmodal={setRiskmodal}
      setEditPatient={setEditPatient}
      setChat={setChat}
      />
    ))
  ) : (
    <div className="text-center text-gray-500 text-sm">No data available</div>
  )}
        </div>
        </InfiniteScroll>
        </div>
      </SideNavLayout>
      <Enrollpatient 
       setToastMessage={setToastMessage}
       setToastSeverity={setToastSeverity}
       selectedCard={selectedCard}
           fetchdata={fetchdata}
       setOpenToast={setOpenToast}
      type={enrolltype} isOpen={enrollform} close={setEnrollForm}
      pidHandled={pidHandled}
      resetFiltercount={resetFiltercount}
      setLimit={setLimit}
          setSelectedTab={    setSelectedTab}
      />

      <FilterPopUp  setSelectedTab={setSelectedTab} fetchdata={fetchdata} setSelectedFilterscounts={setSelectedFilterscounts}  isOpen={filterpopup} close={setFilterPopup} />
      <EditPatient
       setToastMessage={setToastMessage}
       setToastSeverity={setToastSeverity}
       setOpenToast={setOpenToast}
      type={enrolltype} isOpen={editpatient} close={setEditPatient}
      selectedCard={selectedCard}
         pidHandled={pidHandled}
      resetFiltercount={resetFiltercount}
      setLimit={setLimit}
          setSelectedTab={    setSelectedTab}
      />
      <RpmNote 
      setToastMessage={setToastMessage}
      setToastSeverity={setToastSeverity}
      setOpenToast={setOpenToast}
      selectedCard={selectedCard} isOpen={notesform} onClose={setNotesForm}/>
      <RpmFilter fetchdata={fetchdata} isOpen={filterrpmmodal} onClose={handleFilterClose} resetSignal={filterReset} onResetHandled={() => setFilterReset(false)} />
      <Risk
      setSelectedTab={setSelectedTab}
      fetchdata={fetchdata}
       setToastMessage={setToastMessage}
       setToastSeverity={setToastSeverity}
       setOpenToast={setOpenToast}
       selectedCard={selectedCard} isOpen={riskmodal} onClose={setRiskmodal}
      
      />
      <RpmCard isOpen={isRpmCard} onClose={setRpmCard}  selectedCard={selectedCard}/>
         {chat?<ChatWrapper setChat={setChat} patientdata={selectedCard} flow={'comment'} />:<></>}
      <Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={dataLoading}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
                     <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default Rpm;
